import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.css'],
})
export class DateRangePickerComponent {
  constructor(
    public dialogRef: MatDialogRef<DateRangePickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  startDate: Date | null = new Date();
  endDate: Date | null = new Date();
  maxDate = new Date();

  ngOnInit() {
    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onApply() {
    this.dialogRef.close({
      startDate: this.startDate,
      endDate: this.endDate,
    });
  }

  onStartSelect(date: Date | null) {
    if (date) {
      this.startDate = new Date(date);
      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = null;
      }

      this.refreshCalendars();
    }
  }

  onEndSelect(date: Date | null) {
    if (!this.startDate) return;

    if (date) this.endDate = new Date(date);
    this.refreshCalendars();
  }

  renderCalendars: boolean = true;
  refreshCalendars() {
    this.renderCalendars = false;

    requestAnimationFrame(() => {
      this.renderCalendars = true;
    });
  }

  dateRangeClass = (date: Date) => {
    if (!this.startDate || !this.endDate) return '';

    const d = date.setHours(0, 0, 0, 0);
    const start = this.startDate.setHours(0, 0, 0, 0);
    const end = this.endDate.setHours(0, 0, 0, 0);

    if (start === end && d === start) {
      return 'range-single';
    }

    if (d > start && d < end) return 'in-range';
    if (d === start) return 'range-start';
    if (d === end) return 'range-end';

    return '';
  };
}
